import FpUsername from './FpUsername.jsx'
export default FpUsername
